import type { ErrorInfo } from 'react';

const logError = (error: Error, info: ErrorInfo): void => {
  console.error(`Error: ${error}`);
  console.error(`Error message: ${error.message}`);
  console.error(`Error caused by: ${info.componentStack}`);
};

export default logError;
